module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.d08958d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-solid-900.woff
// module id = CYg1
// module chunks = 13 14